import script from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./CRadioGroup.vue?vue&type=script&lang=ts&setup=true"

import "./CRadioGroup.vue?vue&type=style&index=0&id=7f41d01e&lang=scss&scoped=true"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f41d01e"]])

export default __exports__